/**
 * Shell constants, kept out of AppShell.tsx so that file only exports components
 * (react-refresh/only-export-components).
 */

export interface NavItem {
  readonly to: string;
  readonly label: string;
  /** Query-backed badge key; omitted for static entries. */
  readonly counter?: 'alerts' | 'jobs';
}

export interface NavGroup {
  readonly title: string;
  readonly items: readonly NavItem[];
}

/** Grouped by the job the user is doing, not by backend module. */
export const NAV_GROUPS: readonly NavGroup[] = [
  {
    title: '分析',
    items: [
      { to: '/', label: '监测概览' },
      { to: '/analysis/monitoring', label: '舆情监控' },
      { to: '/analysis/intel', label: '事件研判' },
      { to: '/analysis/multimodal', label: '多模态演示' },
      { to: '/reports', label: '报告中心' },
    ],
  },
  {
    title: '处置',
    items: [
      { to: '/alerts', label: '告警', counter: 'alerts' },
      { to: '/tasks', label: '处置任务' },
    ],
  },
  {
    title: '监测配置',
    items: [
      { to: '/topics', label: '监测主题' },
      { to: '/crawlers', label: '采集来源' },
      { to: '/contents', label: '内容库' },
    ],
  },
  {
    title: '系统',
    items: [
      { to: '/jobs', label: '后台作业', counter: 'jobs' },
      { to: '/billing', label: '用量与计费' },
      { to: '/support', label: '支持授权' },
    ],
  },
];

/** Alerts that still need someone's attention; the dashboard uses the same rule. */
export const ACTIVE_ALERT_STATUSES: readonly string[] = ['open', 'acknowledged', 'handling'];
